export default {
    name: 'PersonDialogContactTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        },
        update:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false
    }),
    computed: {
    },
    created () {
    },
    mounted () {
    },
    methods: {
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.personDialogContactTabForm) {
                this.$refs.personDialogContactTabForm.resetValidation()
            }
        }
    }
}
